import { InsuranceTypeEnum } from '../../lib/types/enums/insurance/insurance-type.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentOfficialDocumentsAvailability = {
  paidInvoice: boolean
  participationInvoice: boolean
  confirmationInvoice: boolean
  cancellationInvoice: boolean
  generalProvisionsInsurance: boolean
  takenInsuranceTypes: InsuranceTypeEnum[]
  preBookingInformation: boolean
  pricesDistribution: boolean
  provinceDepartureTravelTerms: boolean
}

export const defaultEnrollmentOfficialDocumentsAvailability: EnrollmentOfficialDocumentsAvailability =
  {
    paidInvoice: false,
    confirmationInvoice: false,
    cancellationInvoice: false,
    participationInvoice: false,
    generalProvisionsInsurance: false,
    takenInsuranceTypes: [],
    preBookingInformation: false,
    pricesDistribution: false,
    provinceDepartureTravelTerms: false
  }

export function getEnrollmentOfficialDocumentsAvailability(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentOfficialDocumentsAvailability.url, { id }))
    .get<EnrollmentOfficialDocumentsAvailability>()
}
